export const VIEW_LIST = 'list';
export const VIEW_CHART = 'chart-mobile';
export const VIEW_VISUAL = 'visual-mobile';
